import _classCallCheck from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\t:lang(ko) {\n\t\tword-break: keep-all;\n\t}\n\tfont-family: 'vw-text', Helvetica, Arial, sans-serif;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\t* {\n\t\tbox-sizing: border-box;\n\t}\n\t", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\t", ";\n\n\tb, strong {\n\t\tfont-weight: bold;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { createGlobalStyle } from '@volkswagen-onehub/styled-components-injectglobal-polyfill';
import * as React from 'react';
import normalize from 'styled-normalize';
import { default as vhCheck } from 'vh-check';
import { styled } from '../theme-provider';
var GlobalStyle = createGlobalStyle(_templateObject(), // tslint:disable-next-line: no-any
normalize);
import { isMobileBrowser } from '../helpers';
import { getMediaQueryVars } from '../theme-provider/get-media-query-vars';
export var StyledIntegratorRoot = styled.div.withConfig({
  displayName: "StyledIntegratorRoot",
  componentId: "sc-7fx0kf"
})(_templateObject2(), getMediaQueryVars());
var BROWSER_ADDRESS_BAR_CSS_VAR_NAME = 'vwa-components-core-browser-address-bar';
/**
 * On mobile browsers address bar isn't taken into account when using `vh` units. This isn't always desired so this method provides computed value that you can use to calculate proper height.
 *
 * For desktop browsers address bar height is 0px.
 *
 * Example:
 * ```
 * main {
 *   height: 100vh; // falback
 *   height: calc(100vh - ${getBrowserBarHeightValue()});
 * }
 * ```
 */

export function getBrowserBarHeightValue() {
  return "var(--".concat(BROWSER_ADDRESS_BAR_CSS_VAR_NAME, ", 0px)");
}

function updateCssVar(cssVarName, value) {
  document.documentElement.style.setProperty("--".concat(cssVarName), "".concat(value, "px"));
}

export var IntegratorRoot =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IntegratorRoot, _React$Component);

  function IntegratorRoot() {
    var _this;

    _classCallCheck(this, IntegratorRoot);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IntegratorRoot).apply(this, arguments));

    _this.updateVh = function () {
      if (_this.vhCheckResult) {
        var result = _this.vhCheckResult.recompute();

        updateCssVar(BROWSER_ADDRESS_BAR_CSS_VAR_NAME, result.value);
      }
    };

    _this.tryUpdateVh = function () {
      if (isMobileBrowser()) {
        _this.timeout = window.setTimeout(function () {
          // on iPhone window height isn't calculated properly at the first try
          if (window.innerHeight > window.screen.height) {
            _this.tryUpdateVh();
          } else {
            window.requestAnimationFrame(_this.updateVh);
          }
        }, 50);
      }
    };

    return _this;
  }

  _createClass(IntegratorRoot, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.vhCheckResult = vhCheck(BROWSER_ADDRESS_BAR_CSS_VAR_NAME);
      this.tryUpdateVh();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.tryUpdateVh();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // remove all listeners that are registered by vh-check
      if (this.vhCheckResult) {
        this.vhCheckResult.unbind();
      }

      if (this.timeout) {
        window.clearTimeout(this.timeout);
        this.timeout = undefined;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(StyledIntegratorRoot, null, React.createElement(GlobalStyle, null), this.props.children);
    }
  }]);

  return IntegratorRoot;
}(React.Component);